<template>
    <div class="c-gallery">
        <div class="c-gallery-main">
            <img class="c-gallery__main-image" :src="selectedImage.src" alt="">
        </div>
        <div v-if="localImages.length > 1" class="c-gallery-thumbs">
            <button class="c-button--reset" v-for="image in images" @click="viewImage(image)"><img :src="image.src" alt=""></button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: ['images'],
        data() {
            return {
                localImages: this.images,
            }
        },
        beforeMount() {
            if (!this.localImages) {
                this.localImages = [{
                    src: require('@/assets/images/no_image.png'),
                    selected: true
                }];
            }
        },
        computed: {
            selectedImage: {
                get() {
                    if (typeof this.localImages === 'string') {
                      return this.localImages;
                    } else {
                      return this.localImages.find((item) => {
                        return item.selected
                      });
                    }
                },
                set(image) {
                    this.localImages.forEach((item) => {
                        if (item !== image) {
                            this.$set(item, 'selected', false);
                        } else {
                            this.$set(item, 'selected', true);
                        }
                    });
                }
            }
        },
        methods: {
            viewImage(image) {
                this.selectedImage = image;
            }
        }
    }
</script>


<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    button {
        padding: 0;
    }

    .c-gallery-thumbs {
        display: grid;
        grid-gap: 5px;
        grid-template-columns: repeat(2, 50px);
        grid-template-rows: 50px 50px 50px;
        grid-auto-flow: column;
        .is-ie11 & {
          display: block;
          button {
            display: block;
            clear: left;
            float: left;
            margin-bottom: 5px;
            margin-right: 5px;
            width: 50px;
            height: 50px;
          }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/gallery/Gallery.vue